import { createSlice } from '@reduxjs/toolkit';

const SiteDetailsDataSlice = createSlice({
    name: 'SiteDetailsData',
    initialState: '',
    reducers: {
        setSiteDetailsData: (state, action) => {
            return action.payload;
        },
        resetSiteDetailsData: (state) => {
            return null;
        },
    },
});

export const { setSiteDetailsData, resetSiteDetailsData } = SiteDetailsDataSlice.actions;
export default SiteDetailsDataSlice.reducer;